import { e2eeCache } from 'APP/cache/e2ee';
import { KeyPackageStorage } from 'APP/libs/mls-rs-wasm';
import { transformArrayBufferToBase64 } from 'UTILS/e2ee/transformArrayBufferToBase64';

export class MlsKeyPackageStorageMemory implements KeyPackageStorage {
  private keyPackages = new Map<string, ArrayBuffer>();
  private readonly clientId: string;

  constructor(clientId: string) {
    this.clientId = clientId;
  }

  async init(): Promise<void> {
    const keyPackageState = await e2eeCache.getKeyPackages(this.clientId);

    if (keyPackageState) {
      this.keyPackages = keyPackageState;
    }
  }

  insert(id: ArrayBuffer, data: ArrayBuffer): void {
    const idString = transformArrayBufferToBase64(id);
    this.keyPackages.set(idString, data);
    e2eeCache.putKeyPackages(this.clientId, this.keyPackages);
  }

  get(id: ArrayBuffer): ArrayBuffer | undefined {
    const idString = transformArrayBufferToBase64(id);
    return this.keyPackages.get(idString);
  }

  delete(id: ArrayBuffer): void {
    const idString = transformArrayBufferToBase64(id);
    this.keyPackages.delete(idString);
    e2eeCache.putKeyPackages(this.clientId, this.keyPackages);
  }

  clearStorage(): void {
    e2eeCache.putKeyPackages(this.clientId, new Map<string, ArrayBuffer>());
  }

  getCount(): number {
    return this.keyPackages.size;
  }
}
